<div class="picture-container no-md-img cf">
    <picture>
        <source *ngIf="mobile.src" srcset="{{mobile.src}}" media="(max-width: 481px)">
        <img src="{{image.src}}" alt="{{image.alt}}" title="{{image.title}}" data-pin-nopin="true" loading="lazy">
    </picture>
    <div class="photo-controls load-img"></div>
    <div class="photo-extras-wrap">
        <div class="photo-extras">
            <div class="caption" [innerHTML]="image.caption"></div>
            <div class="caption mobile" [innerHTML]="image.caption"></div>
        </div> 
    </div>
</div>